var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_196_1030)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 19C16.5326 19 19.6666 15.866 19.6666 12C19.6666 8.13401 16.5326 5 12.6666 5C8.80063 5 5.66663 8.13401 5.66663 12C5.66663 15.866 8.80063 19 12.6666 19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 11.208C13.9382 11.208 14.9689 10.1772 14.9689 8.90562C14.9689 7.63407 13.9382 6.60327 12.6666 6.60327C11.3951 6.60327 10.3643 7.63407 10.3643 8.90562C10.3643 10.1772 11.3951 11.208 12.6666 11.208Z",
    fill: "url(#paint1_linear_196_1030)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 17.3966C11.8207 17.3965 10.9976 17.1227 10.3202 16.616C9.64288 16.1094 9.14772 15.3971 8.90878 14.5856C8.49643 13.1854 9.54616 11.7812 11.006 11.7812H14.3272C15.7871 11.7812 16.8368 13.1848 16.4245 14.5851C16.1856 15.3966 15.6905 16.109 15.0132 16.6158C14.3358 17.1226 13.5126 17.3965 12.6666 17.3966Z",
    fill: "url(#paint2_linear_196_1030)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_1030",
    x1: 10.7575,
    y1: 0.00000418761,
    x2: 31.4618,
    y2: 5.95949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4462EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3DD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_196_1030",
    x1: 12.3003,
    y1: 6.60327,
    x2: 16.2727,
    y2: 7.74667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4462EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3DD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_196_1030",
    x1: 12.0544,
    y1: 11.7813,
    x2: 18.2758,
    y2: 14.2357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4462EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3DD8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedProfile);
export default __webpack_public_path__ + "static/media/selected-profile.65bf16ef22d53ec35b81a399d19b8e2d.svg";
export { ForwardRef as ReactComponent };